import Content from "uxp-documentation/src/pages/uxp-api/reference-css//Selectors/index.md";
import * as React from 'react';
export default {
  Content,
  React
};